export default __webpack_public_path__ + "static/media/cloud-upload-regular-240.8325eb56.png";